module.exports = __webpack_public_path__ + "img/alipay.185b103d.png";